import get from 'lodash/get';
import { getSystemText } from '@/api';

export default {
  data() {
    return {
      nonOrganizerText: null,
    };
  },
  computed: {
    hasOrganizerAccess() {
      return this.$store.getters['users/userAccess'] >= 5;
    },
    loadingProfile() {
      return this.$store.getters['users/loadingProfile'];
    },
  },
  methods: {
    fetchNonOrganizerText: async function fetchNonOrganizerText() {
      if (this.hasOrganizerAccess) return null;

      const userToken = this.$store.getters['auth/userToken'];
      const { data } = await getSystemText(userToken, 'organizer_restricted_access');
      this.nonOrganizerText = get(data, '[1].data.details.text');
      return null;
    },
  },
  watch: {
    hasOrganizerAccess: {
      immediate: true,
      handler: 'fetchNonOrganizerText',
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/organizer.js